import React, { useEffect, useState } from "react";

type SanitizedHtmlProps = {
  html: string | null;
  component?: keyof JSX.IntrinsicElements;
};

const sanitize = async (html: string | null) => {
  const dompurify = await import("dompurify");

  return dompurify.default.sanitize(html || "", { ALLOWED_TAGS: ["a", "br"], ADD_ATTR: ["target"] });
};

const SanitizedHtml = ({ html, component: Component = "span" }: SanitizedHtmlProps) => {
  const [sanitizedHtml, setSanitizedHtml] = useState<string>("");

  useEffect(() => {
    const sanitizeHtml = async () => {
      const sanitizedHtml = await sanitize(html);
      setSanitizedHtml(sanitizedHtml);
    };

    sanitizeHtml();
  }, [html]);

  return (
    <Component
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml,
      }}
    />
  );
};

export default SanitizedHtml;
